import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/home.vue'
import project from '../components/project.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/project',
    name: 'project',
    component: project
    
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
